import api from "./api";

export interface PublicUser {
  id: number;
  email: string;
  plan: string;
  usage: number;
  subscriptionStatus: string;
  balance: number;
}

export interface AuthResponse {
  token?: string;
  message?: string;
  user: PublicUser;
}

export const login = async (email: string, password: string): Promise<AuthResponse> => {
  const response = await api.post<AuthResponse>("/auth/login", { email, password });
  return response.data;
};

export const register = async (email: string, password: string): Promise<AuthResponse> => {
  const response = await api.post<AuthResponse>("/auth/register", { email, password });
  return response.data;
};

export const getMe = async (): Promise<PublicUser> => {
  const response = await api.get<PublicUser>("/auth/me");
  return response.data;
};

export const logout = () => {
  localStorage.removeItem("token");
};
